import { t } from "@lingui/core/macro";
import { z } from "zod";

export const COGNITO_SPECIAL_CHARS = "^$*.[]{}()?\"!@#%&/\\,><':;|_~`=+-";

const cognitoSpecialCharsEscaped = COGNITO_SPECIAL_CHARS.replace(
  /[.*+?^${}()|[\]\\-]/g,
  "\\$&",
);

export const cognitoSpecialCharRegex = new RegExp(
  `[${cognitoSpecialCharsEscaped}]`,
);

const cognitoAllowedCharRegex = new RegExp(
  `^[A-Za-z\\d${cognitoSpecialCharsEscaped}]+$`,
);

export const passwordSchema = z
  .string()
  .min(12, { error: () => t`Password must be at least 12 characters` })
  .regex(/[a-z]/, { error: () => t`Password must contain a lowercase letter` })
  .regex(/[A-Z]/, { error: () => t`Password must contain an uppercase letter` })
  .regex(/\d/, { error: () => t`Password must contain a number` })
  .regex(cognitoSpecialCharRegex, {
    error: () => t`Password must contain a special character`,
  })
  .regex(
    cognitoAllowedCharRegex,
    {
      error: () =>
        t`Invalid character detected. Use letters, numbers, and Cognito-supported symbols only`,
    },
  );
